import { Loader2 } from 'lucide-react';

interface FormFooterProps {
  onCancel: () => void;
  onSave: () => void;
  saveLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: 'default' | 'stacked';
}

export const FormFooter = ({
  onCancel,
  onSave,
  saveLabel = 'Guardar cambios',
  cancelLabel = 'Cancelar',
  isLoading = false,
  disabled = false,
  variant = 'default'
}: FormFooterProps) => {
  if (variant === 'stacked') {
    return (
      <div className="space-y-3">
        <button
          onClick={onSave}
          disabled={disabled || isLoading}
          className="w-full py-3.5 px-6 bg-[#FF6A2A] text-white font-semibold rounded-[14px] hover:bg-[#C2410C] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        >
          {isLoading && <Loader2 className="w-5 h-5 animate-spin" />}
          {isLoading ? 'Guardando...' : saveLabel}
        </button>
        <button
          onClick={onCancel}
          disabled={isLoading}
          className="w-full py-3.5 px-6 bg-white border-2 border-[#E5E7EB] text-[#111827] font-semibold rounded-[14px] hover:bg-[#F7F8FA] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {cancelLabel}
        </button>
      </div>
    );
  }

  return (
    <div className="flex gap-3">
      <button
        onClick={onCancel}
        disabled={isLoading}
        className="flex-1 py-3.5 px-6 bg-white border-2 border-[#E5E7EB] text-[#111827] font-semibold rounded-[14px] hover:bg-[#F7F8FA] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {cancelLabel}
      </button>
      <button
        onClick={onSave}
        disabled={disabled || isLoading}
        className="flex-1 py-3.5 px-6 bg-[#FF6A2A] text-white font-semibold rounded-[14px] hover:bg-[#C2410C] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {isLoading && <Loader2 className="w-5 h-5 animate-spin" />}
        {isLoading ? 'Guardando...' : saveLabel}
      </button>
    </div>
  );
};
